<template>
  <div class="section-container">
    <div class="section-title">符合药监监管要求的行业专属解决方案</div>
    <div class="section-desc">随着《医疗器械经营质量管理规范2024》出台，在新医改的背景下进行了全套解决方案的合规化升级
    </div>
    <div class="process-flow">
      <div class="flow-row">
        <div class="flow-item primary">
          <div class="number">01</div>
          <div class="content">
            <h3>商品追溯</h3>
            <p>平台注册证信息与药监官网实时同步，确保商品合规；平台交易过程透明，确保商品从出厂到植入全程可追溯</p>
          </div>
        </div>
        <div class="flow-item secondary">
          <div class="number">02</div>
          <div class="content">
            <h3>首营资质交换</h3>
            <p>确保平台上所有经营企业符合药监相关资质</p>
          </div>
        </div>
        <div class="flow-item primary">
          <div class="number">03</div>
          <div class="content">
            <h3>权限隔离</h3>
            <p>平台对于不同角色权限隔离，确保各类数据的录入、修改、保存等操作应当符合授权范围、管理制度和操作规程的要求，保证数据真实、准确、安全和可追溯</p>
          </div>
        </div>
        <div class="flow-item secondary">
          <div class="number">04</div>
          <div class="content">
            <h3>出入库复核</h3>
            <p>平台对所有涉及出入库操作强制复核，确保流通过程中商品的质量</p>
          </div>
        </div>
      </div>
      <div class="flow-row">
        <div class="flow-item primary">
          <div class="number">05</div>
          <div class="content">
            <h3>日志审查</h3>
            <p>平台提供了全面的日志审核功能，确保业务过程有据可依</p>
          </div>
        </div>
        <div class="flow-item secondary">
          <div class="number">06</div>
          <div class="content">
            <h3>效期提醒</h3>
            <p>平台对商品效期、注册证效期、合作效期等有多级提醒功能，过效期商品无法进行销售</p>
          </div>
        </div>
        <div class="flow-item primary">
          <div class="number">07</div>
          <div class="content">
            <h3>开放平台</h3>
            <p>平台提供了丰富的开放平台接口，可快速与第三方进行数据打通，规避因人为操作而引起的数据不准确</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CoreItemOne'
}
</script>

<style lang="scss" scoped>
.process-flow {
  max-width: 1200PX;
  margin: 40PX auto;
  padding: 0 $spacing-lg;
  display: flex;
  flex-direction: column;
  position: relative;
  flex-wrap: wrap;
  gap: 3PX;
  justify-content: center;
  align-items: center;
  padding: $spacing-xl 0;

  &::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 5%;
    right: 5%;
    border-top: 2PX dashed rgba($primary-color, 0.5);
    z-index: 0;
  }
}

.flow-row {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 8%;
    right: 8%;
    border-top: 2PX solid rgba($primary-color, 0.35);
    z-index: 0;
  }
}

.flow-item {
  width: 260PX;
  height: 260PX;
  position: relative;
  z-index: 1;
  clip-path: polygon(50% 0%, 100% 24%, 100% 76%, 50% 100%, 0% 76%, 0% 24%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: $spacing-md $spacing-lg $spacing-sm;
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-5PX);
    .number {
      opacity: 0.15;
    }

    .content {
      transform: translateY(-$spacing-xl);
      p {
        max-height: 200PX;
        opacity: 1;
        margin-top: $spacing-xs;
        text-align: left;
      }
    }
  }

  &.primary {
    background: $primary-color;
  }

  &.secondary {
    background: $text-color-secondary;
  }

  .number {
    font-size: 36PX;
    font-weight: bold;
    color: $white;
    margin-bottom: $spacing-xs;
    line-height: 1;
    transition: opacity 0.3s ease;
  }

  .content {
    text-align: center;
    color: $white;
    width: 100%;
    transition: all 0.3s ease;
    transform: translateY(0);

    h3 {
      font-size: 18PX;
      margin-bottom: $spacing-xs;
      font-weight: normal;
      line-height: 1.2;
      transition: font-weight 0.3s ease;
      font-weight: bold;
    }

    p {
      font-size: 14PX;
      line-height: 1.5;
      margin: 0;
      padding: 0 $spacing-xs;
      opacity: 0;
      max-height: 0;
      overflow: hidden;
      transition: all 0.3s ease;
    }
  }

  // 添加中等屏幕的响应式设计
  @media screen and (max-width: 1200PX) {
    width: 240PX;
    height: 240PX;
    
    .number {
      font-size: 32PX;
    }
    
    .content h3 {
      font-size: 16PX;
    }
    
    .content p {
      font-size: 13PX;
    }
  }
}
@media screen and (max-width: $screen-md) {
  
  .process-flow {
    padding: $spacing-md;
    flex-direction: column;
    gap: $spacing-md;
    &::after {
      display: none;
    }
  }

  .flow-row {
    flex-direction: column;
    gap: 20PX;

    &::after {
      display: none;
    }
  }

  .flow-item {
    width: 220PX;
    height: 220PX;
    padding: $spacing-sm $spacing-md $spacing-xs;

    &:hover .content {
      transform: translateY(-$spacing-lg);
    }

    .number {
      font-size: 30PX;
      margin-bottom: 0;
    }

    .content {
      h3 {
        font-size: 16PX;
        margin-bottom: $spacing-xs;
      }

      p {
        font-size: 12PX;
        line-height: 1.4;
        padding: 0 $spacing-xs;
      }
    }
  }
}

// 添加小屏幕的响应式设计
@media screen and (max-width: 480PX) {
  .process-flow {
    padding: $spacing-sm;
    gap: $spacing-sm;
  }

  .flow-row {
    gap: 15PX;
  }

  .flow-item {
    width: 200PX;
    height: 200PX;
    padding: $spacing-xs $spacing-sm;

    .number {
      font-size: 28PX;
    }

    .content {
      h3 {
        font-size: 14PX;
      }

      p {
        font-size: 11PX;
      }
    }
  }
}
</style>